var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"footer"},[_vm._v(" Copyright © 湖北大学、湖北省教育信息化发展中心 ")])])}]

export { render, staticRenderFns }